module.exports = __webpack_public_path__ + "media/images/return-icon-908fe89de0956c5a3daf926ea6be0ef172d0fa43b3ab17481896abf0a9e6dbfb.svg";